import React, { Component } from "react";
import Modal from 'react-modal';
import {useState, useEffect} from 'react';
import api from '../../../config.js';
import { checkWhichIconMustToBeReturned, getListFromFlow, getPermission, showMessageError } from '../../../classes/functions';
import './requests.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { Link } from 'react-router-dom';
import TablePagination from "../../../components/TablePagination/index.js";
import StatusButton from "../../../components/StatusButton/index.js";
import ModalStatus from "../../../components/Modal/ModalStatus/index.js";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '900px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function ReturnRequest(){
  const [list, setList] = useState([]);
  const [showSelectStatus, setShowSelectStatus] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [termSearch, setTermSearch] = useState('');
  const [carrying, setCarrying] = useState(true);
  const [listStatus, setListStatus] = useState([]);
  const [listChangeStatus, setListChangeStatus] = useState([]);
  const [itemChange, setItemChange] = useState({});
  const [novo_status, setNovoStatus] = useState('');
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [pesquisa_origem, setPesquisaOrigem] = useState('');
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusButtonWasClicked, setStatusButtonWasClicked] = useState(false);
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  
  let delay;
  function search() {
    clearTimeout(delay);
    
    delay = setTimeout(() => {  
      let data = {
        data: {
          termSearch: termSearch,
          status: selectedStatus,
          origem: pesquisa_origem,
          page: page,
          qtdePage: qtdePage,
        }
      };
  
      api.post("/api/return_request/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, qtdePage);

          setStatusButtonWasClicked(false);
          setShowSelectStatus(false);
          
          setCarrying(false);
        }
      ).catch((error) => {
        toast.error('Ops! Ocorreu um erro.');
        setCarrying(false);
      });
    }, 750);
  }

  function getStatus(){
    api
    .get("/api/generics/getItens?table=8B")
    .then((response) => {
      setListStatus(response.data);
    })
    .catch((error) => {
      toast.error('Ops! Ocorreu um erro.');
    });
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }
  
  function openModalToEvaluate(item) {
    setItemChange(() => item);
    setListChangeStatus(getListFromFlow(item.fluxo, listStatus));
    setModalStatus(true);
  }
  
  function closeModal() {
    setModalStatus(false);
  }
  
  function changeStatus() {
    setCarrying(true);
    setModalStatus(false);
    if (novo_status != '') {
      let data = {
        data: {
          termSearch: termSearch,
          page: 1,
          qtdePage: qtdePage,
          status: novo_status,
          id: itemChange.id
        }
      };
  
      api.post("/api/return_request/changeStatus", data)
      .then((response) => {
        toast.success('Status Alterado.');
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setCarrying(false);
  
        setPage(page-1);
        setQtdePage(qtdePage);
        setModalStatus(false);
        setNovoStatus('');
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      toast.error('Selecione um status.');    
    }
  }

  useEffect(() => {
    search();
  }, [termSearch, pesquisa_origem, page, qtdePage]);

  useEffect(() => {
    if(statusButtonWasClicked){
      search();
    }
  }, [statusButtonWasClicked]);

  useEffect(() => {
    getStatus();
  }, []);
    
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Requisição de Devolução">
          <select className='selectQtdeItens' value={qtdePage} onChange={(e) => setQtdePage(e.target.value)}>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" type="text" onChange={(e) => setTermSearch(e.target.value)} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  <StatusButton
                    showSelectStatus={showSelectStatus}
                    setShowSelectStatus={setShowSelectStatus} 
                    listStatus={listStatus}
                    setListStatus={setListStatus}
                    selectedStatus={selectedStatus}
                    setSelectedStatus={setSelectedStatus}
                    setStatusButtonWasClicked={setStatusButtonWasClicked}
                  />
                </th>
                <th scope="col">Cliente</th>
                <th scope="col">Usuário</th>
                <th scope="col">Data</th>
                <th scope="col">Hora</th>
                <th scope="col">
                  <div scope="col" className="formDiv">
                    <select value={pesquisa_origem} onChange={ (e) => setPesquisaOrigem(e.target.value)} >
                      <option value="">Origem</option>
                      <option value="E">EPI</option>
                      <option value="C">Consumo</option>
                    </select>
                  </div>
                </th>
                <th scope="col">Aprovador</th>
                <th scope="col">Observação</th>
                <th scope="col">Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="">{item.id}</td>
                    <td title={item.label_status} data-label="">{checkWhichIconMustToBeReturned(item.label_status, "2rem")}</td>
                    <td data-label="">{item.cliente}</td>
                    <td data-label="">{item?.usuario_solicitante?.nome}</td>
                    <td data-label="">{item.data}</td>
                    <td data-label="">{item.hora}</td>
                    <td data-label="">{item.origin}</td>
                    <td data-label="">{item.aprovador}</td>
                    <td data-label="">{item.observacao}</td>
                    <td data-label="Opções">
                      {(item?.usuario_solicitante?.id != localStorage.usuario || getPermission('OPERACOES - REQUISICAO DEVOLUCAO - SUPER APROVADOR')) && getPermission('OPERACOES - REQUISICAO DEVOLUCAO - APROVAR DEVOLUCAO') && item.fluxo != '' && <Link className="action" onClick={() => openModalToEvaluate(item)} >
                        <FaCog color="#000" size={17} data-tip="Avaliar Solicitação"/>
                      </Link>}
                      {getPermission('OPERACOES - REQUISICAO DEVOLUCAO - CADASTRO') && <Link className="action" to={`/return_request/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} data-tip="Editar"/>
                      </Link>}
                      <ReactTooltip />
                      <Link className="action" to={`/return_request/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} data-tip="Visualizar"/>
                      </Link>
                      <ReactTooltip />
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <TablePagination limitPage={limitPage} setLimitPage={setLimitPage} page={page} pesquisa_status={pesquisa_status} qtdePage={qtdePage} setCarrying={setCarrying} setList={setList} setPage={setPage} setQtdePage={setQtdePage} setTotal={setTotal} termSearch={termSearch} API="/api/return_request/getSearch" params={{}}/>
      </div>}

      <ModalStatus modalStatus={modalStatus} setModalStatus={setModalStatus} newStatus={novo_status} setNewState={setNovoStatus} states={listChangeStatus} changeStatus={changeStatus}></ModalStatus>
    </div>
  )
}